"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
var rpc_1 = require("./rpc");
var types_1 = require("./types");
var REQUEST_INTERVAL = 600;
var TIMEOUT_INTERVAL = 3000;
var interval = null;
var connected = false;
function connect(schema, options) {
    if (schema === void 0) { schema = {}; }
    if (options === void 0) { options = {}; }
    return new Promise(function (resolve, reject) {
        var localMethods = helpers_1.extractMethods(schema);
        // on handshake response
        function handleHandshakeResponse(event) {
            if (event.data.action !== types_1.actions.HANDSHAKE_REPLY)
                return;
            // register local methods
            var unregisterLocal = rpc_1.registerLocalMethods(schema, localMethods, event.data.connectionID);
            // register remote methods
            var _a = rpc_1.registerRemoteMethods(event.data.schema, event.data.methods, event.data.connectionID, event), remote = _a.remote, unregisterRemote = _a.unregisterRemote;
            // close the connection and all listeners when called
            var close = function () {
                self.removeEventListener(types_1.events.MESSAGE, handleHandshakeResponse);
                unregisterRemote();
                unregisterLocal();
            };
            connected = true;
            // resolve connection object
            var connection = { remote: remote, close: close };
            return resolve(connection);
        }
        // subscribe to HANDSHAKE REPLY MESSAGES
        self.addEventListener(types_1.events.MESSAGE, handleHandshakeResponse);
        var payload = {
            action: types_1.actions.HANDSHAKE_REQUEST,
            methods: localMethods,
            schema: JSON.parse(JSON.stringify(schema)),
        };
        interval = setInterval(function () {
            if (connected)
                return clearInterval(interval);
            // publish the HANDSHAKE REQUEST
            if (helpers_1.isWorker())
                self.postMessage(payload);
            else
                window.parent.postMessage(payload, "*");
        }, REQUEST_INTERVAL);
        // timeout the connection after a time
        setTimeout(function () {
            if (!connected)
                reject("connection timeout");
        }, TIMEOUT_INTERVAL);
    });
}
exports.default = ({
    connect: connect,
});
//# sourceMappingURL=guest.js.map